module.exports = __webpack_public_path__ + "static/media/white_badge.e74da8bb.png";